<template>
  <div class="router-view search-container">
    <div class="search-bar">
      <div class="input">
        <div class="select" @click.stop="sheetVisible = !sheetVisible">
          <span class="display">{{ name }}</span>
          <i class="iconfont icondown-copy1"></i>
        </div>
        <input v-show="gdb3" type="search" v-model="keyword" class="keyword" @keyup.enter="search" ref="keyword">
        <input v-show="gdb2" type="search" v-model="keyword" class="keyword" @keyup.enter="search1" ref="keyword">
      </div>
      <div v-if="gdb3">
        <span class="cancel" @click.stop="search">搜索</span>
      </div>
      <div v-if="gdb2">
        <span class="cancel" @click.stop="search1">搜索</span>
      </div>
      <div class="cancel1" @click="back" >取消</div>
    </div>

    <van-action-sheet
      :actions=" child === 1 && this.sample_type != 'childwes_zy' ? actions : this.sample_type === 'childwes_zy' ?  actionss : action"
      v-model="sheetVisible"
      @select="changeSelect"
    />
    <div class="box-body">
      <div v-if="gdb3">
        <router-link v-for="item in list" :key="item.id" :to="getUrl(item.id, item.type)">
          <van-cell :value="item.name" is-link />
        </router-link>
      </div>
      <div v-if="gdb2">
        <router-link v-for="item in list" :key="item.itemid" :to="getUrl(item.itemid, item.type)">
          <van-cell :value="item.name" is-link />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, ActionSheet } from 'vant'
export default {
  components:{
    [ActionSheet.name]: ActionSheet   
  },
  data () {
    return {
      sample_type: this.util.getLS(this.api.sample_type),
      gdb3: false,
      gdb2: false,
      sheetVisible: false,
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      list: [],
      actions: [
        {
          name: '疾病风险',
          type: 'disease',
          method: this.changeSelect
        },
        {
          name: '单基因病',
          type: 'inherit',
          method: this.changeSelect
        },
        {
          name: '可治罕见病',
          type: 'rare',
          method: this.changeSelect
        },
        {
          name: '精准用药',
          type: 'drug',
          method: this.changeSelect
        },
        {
          name: '特质基因',
          type: 'talent',
          method: this.changeSelect
        }
      ],
      actionss: [
        {
          name: '疾病风险',
          type: 'disease',
          method: this.changeSelect
        },
        {
          name: '单基因病',
          type: 'inherit',
          method: this.changeSelect
        },
        {
          name: '可治罕见病',
          type: 'rare',
          method: this.changeSelect
        },
        {
          name: '特质基因',
          type: 'talent',
          method: this.changeSelect
        }
      ],
      action: [
        {
          name: '疾病风险',
          type: 'disease',
          method: this.changeSelect
        },
        {
          name: '单基因病',
          type: 'inherit',
          method: this.changeSelect
        },
        {
          name: '精准用药',
          type: 'drug',
          method: this.changeSelect
        },
        {
          name: '特质基因',
          type: 'talent',
          method: this.changeSelect
        }
      ],
      type: 'disease',
      keyword: '',
      name: '疾病风险'
    }
  },
  methods: {
    back(){
     this.$router.back()
    },
    changeSelect (e) { // 项目切换
      this.sheetVisible = false
      this.name = e.name
      this.type = e.type
      this.list = []
    },
    focusKeyword () {
      this.$refs['keyword'].focus()
    },
    search () {
      let keyword = this.keyword
      let that = this
      if (keyword === '') {
        Toast('关键字不可为空')
        return false
      }
      this.util.get(this.api.search + '?type=' + that.type + '&name=' + that.keyword, '', (resp) => {
        if (resp.items.length === 0) {
          Toast('未搜到关键字')
        } else {
          that.list = resp.items
        }
        that.$refs['keyword'].blur()
      })
    },
    getUrl (id, type) {
      let path = ''
      if (type === 'tumour') {
        return '/diseaseInfo/' + id + '/tumour'
      } else if (type === 'disease') {
        return '/diseaseInfo/' + id + '/disease'
      } else {
        switch (this.type) {
          case 'inherit':
            path = '/inheritInfo/'
            return path + id
          case 'rare':
            path = '/rareInfo/'
            return path + id
          case 'drug':
            path = '/drugInfo/'
            return path + id
          case 'talent':
            path = '/talentInfo/'
            return path + id
        }
      }
    },
    // gdb2
    search1 () {
      // 肿瘤:1/疾病:2/单基因:3/药物:4/特质:5
      let keyword = this.keyword
      let that = this
      if (keyword === '') {
        Toast('关键字不可为空')
        return false
      }
      if (this.type === 'disease') {
        that.type = 2
      } else if (this.type === 'inherit') {
        that.type = 3
      } else if (this.type === 'drug') {
        that.type = 4
      } else if (this.type === 'talent') {
        that.type = 5
      } else {}
      this.util.get1(this.api.search1 + '?system=' + that.type + '&keyword=' + that.keyword, '', (resp) => {
        if (resp.length === 0) {
          Toast('未搜到关键字')
        } else {
          that.list = resp
        }
        that.$refs['keyword'].blur()
      })
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.focusKeyword()
    } else {
      this.gdb2 = true
      this.focusKeyword()
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .search-container {
    background-color: #fff;
    min-height: 200px;
    padding-top: 15px;

    .search-bar {
      position: relative;
      margin: 0 56px 0 15px;
      line-height: pxToRem(60px);

      .input {
        border: 1px solid #eee;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        width: 90%;
      }

      .select {
        position: absolute;
        left: 0;
        /*width: 84px;*/
        padding: 0 pxToRem(20px);
        border-right: 1px solid #eee;
        text-align: center;
        /*padding-right: 10px;*/
        font-size: 0.14rem;

        ul {
          //display: none;
          position: absolute;
          top: 100%;
          border-left: 1px solid #eee;
          border-right: 1px solid #eee;
          width: 100%;
        }

        .icon-down {
          top: 0.5em;
          bottom: 0;
          margin: auto 0;
          display: block;
          position: absolute;
          right: 10px;
          left: unset;
          border-top-color: #666;
        }
      }

      .keyword {
        border: none;
        height: pxToRem(60px);
        outline: none;
        padding: 0 10px 0 100px;
        width: 100%;
      }

      .cancel {
        position: absolute;
        right: - 0.08rem;
        top: 0;
      }
      .cancel1 {
        position: absolute;
        right: -.48rem;
        top: 0;
      }
    }
  }

  .router-view {
    height: 100%;
  }

  .gk-cell a {
    color: #666;
    text-decoration: none;
    display: block;

    &:active, &:focus {
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue